import {
    createSelector
} from 'reselect';

export const BookOrderSelector = (state) => state.bookOrder;
export const getBookOrderList = createSelector(
    [BookOrderSelector],
    (state) => state.bookOrders
);
